import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { DEFAULT_GAS_CHANNEL } from '../events';
import { AnalyticsListener } from '@atlaskit/analytics-next';
export var SearchDialogAnalyticsContext = function SearchDialogAnalyticsContext(_ref) {
  var analyticContext = _ref.analyticContext,
    _ref$nonPrivacySafeAn = _ref.nonPrivacySafeAnalyticContext,
    nonPrivacySafeAnalyticContext = _ref$nonPrivacySafeAn === void 0 ? {} : _ref$nonPrivacySafeAn,
    _ref$filterAnalyticsC = _ref.filterAnalyticsContext,
    filterAnalyticsContext = _ref$filterAnalyticsC === void 0 ? {} : _ref$filterAnalyticsC,
    nonPrivacySafeAnalyticContextGenerator = _ref.nonPrivacySafeAnalyticContextGenerator,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(AnalyticsListener, {
    channel: DEFAULT_GAS_CHANNEL,
    onEvent: function onEvent(event) {
      var additionalAttributes = typeof analyticContext === 'function' ? analyticContext() : analyticContext;
      var nonPrivacySafeAttributes = nonPrivacySafeAnalyticContextGenerator !== undefined ? nonPrivacySafeAnalyticContextGenerator() : nonPrivacySafeAnalyticContext;
      event.update(function (payload) {
        var _payload$attributes;
        var filters = _objectSpread(_objectSpread({}, (_payload$attributes = payload.attributes) === null || _payload$attributes === void 0 ? void 0 : _payload$attributes.filters), filterAnalyticsContext);
        // Operational event not support nonPrivacySafeAttributes
        var nonPrivacySafeAttributesPayload = payload.eventType === 'operational' ? {} : {
          nonPrivacySafeAttributes: _objectSpread(_objectSpread({}, payload === null || payload === void 0 ? void 0 : payload.nonPrivacySafeAttributes), nonPrivacySafeAttributes)
        };
        return _objectSpread(_objectSpread({}, payload), {}, {
          attributes: _objectSpread(_objectSpread(_objectSpread({}, payload.attributes), additionalAttributes), {}, {
            filters: Object.keys(filters).length > 0 ? filters : undefined
          })
        }, nonPrivacySafeAttributesPayload);
      });
    }
  }, children);
};